
enum MarketInsightPriceIndexState {
	NOT_AVAILABLE = "NOT_AVAILABLE", SOLD_OUT = "SOLD_OUT", AVAILABLE = "AVAILABLE"
}

export default MarketInsightPriceIndexState;